import PropertyInfo from '../Model/PropertyInfo';
import PropertyInstance from '../Model/PropertyInstance';
import { RuleContext } from './RuleContext';
/**
 * Acts as a proxy for a model in order to tell which properties of the model were accessed during the invocation of a rule.
 */
var ModelProxy = /** @class */ (function () {
    function ModelProxy(instance) {
        var _this = this;
        this.accessedProperties = new Map();
        this.defaultPropertyInstance = new PropertyInstance(this, new PropertyInfo(""), false);
        var _loop_1 = function (propertyName) {
            Object.defineProperty(this_1, propertyName, {
                get: function () {
                    _this.accessedProperties.set(propertyName, instance.constructor.neo.meta[propertyName].propertyInfo);
                    return instance.meta[propertyName].peek();
                }
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.getOwnPropertyNames(instance); _i < _a.length; _i++) {
            var propertyName = _a[_i];
            _loop_1(propertyName);
        }
    }
    /**
     * Invokes checkRule on the provided rule, and monitors which properties were accessed.
     * The accessed properties are returned as a propertyInfo array.
     * This technique will not always extract all properties.
     *   E.g. Given: (Property1 !== "" && Property1 === Property2)
     *        Property2 will not be extracted if Property1's default value is an empty string.
     * Any exceptions thrown will be caught silently.
     */
    ModelProxy.prototype.tryExtractProperties = function (rule) {
        this.accessedProperties.clear();
        var context = new RuleContext(null);
        try {
            rule.checkRule(this.defaultPropertyInstance, context);
        }
        catch (e) {
        }
        return Array.from(this.accessedProperties.values());
    };
    return ModelProxy;
}());
export default ModelProxy;
